import Device from "../models/device";
import NFTS from "./dummy_data";
const DEVICES = [
  new Device(
    "d1",
    "uid1",
    "SILO 1",
    {
      power: "ON",
      mode: "play",
      volume: 100,
      mute: false,
      brightness: 100,
      brightAuto: false,
    },
    { list: NFTS }
  ),
  new Device(
    "d2",
    "uid1",
    "SILO 2",
    {
      power: "ON",
      mode: "play",
      volume: 100,
      mute: false,
      brightness: 100,
      brightAuto: false,
      speed: "5mins",
    },
    { list: NFTS }
  ),
  new Device(
    "d3",
    "uid1",
    "SILO 3",
    {
      power: "ON",
      mode: "play",
      volume: 100,
      mute: false,
      brightness: 100,
      brightAuto: false,
      speed: "5mins",
    },
    { list: NFTS }
  ),
];

export default DEVICES;
